import type { Component, DivComponent, LinkComponent, Props } from './types';

import { IosArrowLeftHeader } from '@sgcmpteltd/uikit-react/components/icons';
import Link from 'next/link';

import { cn } from '@/lib/utils';

const LinkComponentFC: LinkComponent = ({ children, className, href }) => {
  return <Link className={className} href={href}>{children}</Link>;
};

const DivComponentFC: DivComponent = ({ children, className, onClick }) => {
  return (
    <div
      className={cn('text-link', className)}
      onClick={onClick}
      onKeyDown={e => e.preventDefault()}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  );
};

const CommonChildren = ({ label }: Pick<Props, 'label'>) => {
  return (
    <>
      <span className="my-[0.4rem] ml-[0.2rem] mr-1">
        <IosArrowLeftHeader size={16} />
      </span>
      <span className="text-sm font-medium text-link">{label}</span>
    </>
  );
};

export const BackButtonComponent: Component = ({ href, isLink, label, onClick }) => {
  return isLink
    ? (
        <LinkComponentFC className="flex items-center gap-[1.2rem]" href={href}>
          <CommonChildren label={label} />
        </LinkComponentFC>
      )
    : (
        <DivComponentFC className="flex items-center gap-[1.2rem]" onClick={onClick}>
          <CommonChildren label={label} />
        </DivComponentFC>
      );
};
